var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.c_data } },
        [
          _c(
            "el-table",
            {
              ref: "dataTable",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                data: _vm.c_data,
                border: "",
                "header-cell-class-name": _vm.headerCellClassName,
              },
            },
            [
              _vm.canEdit
                ? _c("el-table-column", {
                    attrs: { align: "center", type: "selection", width: "55" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "facilityName",
                  label: "Supplier/Facility",
                  width: "250px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isNew == "N" || !_vm.c_canEdit
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        title: scope.row.plantName,
                                        disabled: "",
                                      },
                                      model: {
                                        value: scope.row.plantName,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "plantName", $$v)
                                        },
                                        expression: "scope.row.plantName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: `[${scope.$index}].plantId`,
                                      rules: _vm.requiredRule,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { disabled: !_vm.c_canEdit },
                                        model: {
                                          value: scope.row.plantId,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "plantId", $$v)
                                          },
                                          expression: "scope.row.plantId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.plantList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.supplierName,
                                              value: item.tmSupplierId,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "supplierDc",
                  label: "Supplied DC",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].supplierDc`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled:
                                    !_vm.c_canEdit ||
                                    scope.row.transportationMethod ==
                                      "SUPPLIER",
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeCurrentFreight(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.supplierDc,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "supplierDc", $$v)
                                  },
                                  expression: "scope.row.supplierDc",
                                },
                              },
                              _vm._l(_vm.dcList, function (item, index) {
                                return _c("el-option", {
                                  attrs: {
                                    label: item.dcName,
                                    value: item.tmDcId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "tradeTerm",
                  label: "Trade Term",
                  width: 200,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].tradeTerm`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TM_MATERIAL_RECORD",
                                field: "PRICE_TYPE",
                                disabled:
                                  !_vm.c_canEdit || scope.row.isNew == "N",
                              },
                              model: {
                                value: scope.row.tradeTerm,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "tradeTerm", $$v)
                                },
                                expression: "scope.row.tradeTerm",
                              },
                            }),
                            scope.row.tradeTerm == "5"
                              ? _c("el-input", {
                                  attrs: {
                                    title: scope.row.tradeTermOther,
                                    maxlength: "30",
                                  },
                                  model: {
                                    value: scope.row.tradeTermOther,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "tradeTermOther", $$v)
                                    },
                                    expression: "scope.row.tradeTermOther",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.isSupplier
                ? _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      align: "center",
                      prop: "newBoolean",
                      width: "100",
                      label: _vm.$t("fpaManage.permanent.isNew"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": "Y",
                                      disabled: !_vm.c_canEdit,
                                      "inactive-value": "N",
                                    },
                                    model: {
                                      value: scope.row.isNew,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "isNew", $$v)
                                      },
                                      expression: "scope.row.isNew",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      615916300
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "localItem",
                  label: "Local Item#",
                  width: "150px",
                  "column-key": "localItem",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].localItem`,
                              rules:
                                scope.row.isNew == "Y" ? [] : _vm.requiredRule,
                            },
                          },
                          [
                            _c("MaterialInput", {
                              attrs: {
                                "can-pick": scope.row.isNew == "N",
                                disabled:
                                  !_vm.c_canEdit || scope.row.isNew == "Y",
                              },
                              on: {
                                pick: function ($event) {
                                  return _vm.pickMaterial($event, scope.row)
                                },
                              },
                              model: {
                                value: scope.row.localItem,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "localItem", $$v)
                                },
                                expression: "scope.row.localItem",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "productDescription",
                  label: "Product Description",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].productDescription`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                title: scope.row.productDescription,
                                disabled:
                                  !_vm.c_canEdit || scope.row.isNew == "N",
                              },
                              model: {
                                value: scope.row.productDescription,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "productDescription", $$v)
                                },
                                expression: "scope.row.productDescription",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "packingSizePerUom",
                  label: "Packing Size per SU",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].packingSizePerUom`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                title: scope.row.packingSizePerUom,
                                disabled:
                                  !_vm.c_canEdit || scope.row.isNew == "N",
                              },
                              model: {
                                value: scope.row.packingSizePerUom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "packingSizePerUom", $$v)
                                },
                                expression: "scope.row.packingSizePerUom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "uom",
                  label: "Settlement Unit (per SU)",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].uom`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TM_MATERIAL_RECORD",
                                disabled:
                                  !_vm.c_canEdit || scope.row.isNew == "N",
                                field: "MINIMUM_ORDER_UNIT",
                              },
                              model: {
                                value: scope.row.uom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "uom", $$v)
                                },
                                expression: "scope.row.uom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "currentPricePerUom",
                  label: "Current Price per UoM (excluding VAT)",
                  width: "170px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].currentPricePerUom`,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                title: scope.row.currentPricePerUom,
                                disabled: true,
                              },
                              model: {
                                value: scope.row.currentPricePerUom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "currentPricePerUom", $$v)
                                },
                                expression: "scope.row.currentPricePerUom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "newPricePerUom",
                  label: "New Price per UoM (excluding VAT)",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].newPricePerUom`,
                              rules: [_vm.requireRule, _vm.priceRule],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.c_canEdit,
                                title: scope.row.newPricePerUom,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.sumDDPCost(scope.row)
                                },
                                change: function ($event) {
                                  return _vm.changeNunToSixBit(
                                    scope.row,
                                    "newPricePerUom"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.newPricePerUom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "newPricePerUom", $$v)
                                },
                                expression: "scope.row.newPricePerUom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "currency",
                  label: "Currency",
                  width: "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].currency`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                filterable: true,
                                table: "BASE",
                                field: "CURRENCY_CODE",
                                disabled: true,
                              },
                              model: {
                                value: scope.row.currency,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "currency", $$v)
                                },
                                expression: "scope.row.currency",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "vat",
                  label: "VAT",
                  width: "80px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].currency`,
                              rules:
                                scope.row.isNew == "Y" ? _vm.requiredRule : [],
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TM_MATERIAL_RECORD",
                                field: "URCHASE_TAX_RATE",
                                disabled: !_vm.c_canEdit,
                              },
                              model: {
                                value: scope.row.vat,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "vat", $$v)
                                },
                                expression: "scope.row.vat",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "change",
                  label: "Change",
                  width: "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: `[${scope.$index}].change` } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80%" },
                              attrs: {
                                disabled: "",
                                value: _vm.changePercent(
                                  scope.row.newPricePerUom,
                                  scope.row.currentPricePerUom
                                ),
                              },
                            }),
                            _vm._v("% "),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "transportationMethod",
                  label: "Delivery Type",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].transportationMethod`,
                              rules:
                                scope.row.isNew == "N" ? [] : _vm.requiredRule,
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TM_MATERIAL",
                                field: "DIS_TYPE",
                                disabled: !_vm.c_canEdit,
                                excludes: ["thirdParty"],
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeCurrentFreight(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.transportationMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "transportationMethod",
                                    $$v
                                  )
                                },
                                expression: "scope.row.transportationMethod",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "freight",
                  label: "Freight",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.transportationMethod != "DC"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `[${scope.$index}].freight`,
                                  rules: [_vm.requireRule, _vm.priceRule],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: !_vm.c_canEdit },
                                  on: {
                                    input: function ($event) {
                                      return _vm.sumDDPCost(scope.row)
                                    },
                                    change: function ($event) {
                                      return _vm.changeNunToSixBit(
                                        scope.row,
                                        "freight"
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.freight,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "freight", $$v)
                                    },
                                    expression: "scope.row.freight",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "currentFreight",
                  label: "Current Freight",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.currentFreight))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "ddpCost",
                  label: "Total Cost(excluding VAT)",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].ddpCost`,
                              rules: [_vm.requireRule, _vm.priceRule],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              on: {
                                change: function ($event) {
                                  return _vm.changeNunToSixBit(
                                    scope.row,
                                    "ddpCost"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.ddpCost,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "ddpCost", $$v)
                                },
                                expression: "scope.row.ddpCost",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "validFrom",
                  label: "Valid From(Date)",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].validFrom`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "picker-options": {
                                  disabledDate: _vm.maxData(scope.row.validTo),
                                },
                                type: "date",
                                placeholder: "选择日期",
                                disabled: !_vm.c_canEdit,
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: scope.row.validFrom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "validFrom", $$v)
                                },
                                expression: "scope.row.validFrom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "validTo",
                  label: "Valid To(Date)",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].validTo`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "picker-options": {
                                  disabledDate: _vm.minDate(
                                    scope.row.validFrom
                                  ),
                                },
                                type: "date",
                                placeholder: "选择日期",
                                disabled: !_vm.c_canEdit,
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: scope.row.validTo,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "validTo", $$v)
                                },
                                expression: "scope.row.validTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "volumeEstimation",
                  label: "Volume Estimation",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].volumeEstimation`,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              on: {
                                change: function ($event) {
                                  return _vm.changeNunToSixBit(
                                    scope.row,
                                    "volumeEstimation"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.volumeEstimation,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "volumeEstimation", $$v)
                                },
                                expression: "scope.row.volumeEstimation",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "contentPerUom",
                  label: "Content Per SU",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: { prop: `[${scope.$index}].contentPerUom` },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              on: {
                                input: function ($event) {
                                  return _vm.sumDDPCost(scope.row)
                                },
                                change: function ($event) {
                                  return _vm.changeNunToSixBit(
                                    scope.row,
                                    "contentPerUom"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.contentPerUom,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "contentPerUom", $$v)
                                },
                                expression: "scope.row.contentPerUom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "unit",
                  label: "Unit",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: `[${scope.$index}].unit` } },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TT_FPA_PQCN",
                                field: "UNIT",
                                disabled: !_vm.c_canEdit,
                              },
                              model: {
                                value: scope.row.unit,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "unit", $$v)
                                },
                                expression: "scope.row.unit",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "pricePerUnit",
                  label: "Price per Unit",
                  width: "150px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: `[${scope.$index}].pricePerUnit` } },
                          [
                            _c("el-input", {
                              attrs: {
                                title: scope.row.pricePerUnit,
                                disabled: "",
                              },
                              model: {
                                value: scope.row.pricePerUnit,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "pricePerUnit", $$v)
                                },
                                expression: "scope.row.pricePerUnit",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "remark",
                  label: "Remark",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: `[${scope.$index}].remark` } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.c_canEdit,
                                title: scope.row.remark,
                              },
                              model: {
                                value: scope.row.remark,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "remark", $$v)
                                },
                                expression: "scope.row.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }